import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Header,
  Modal,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { fetchM } from '../../actions/fetchM';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

import ConsentPin from './ConsentPin';

class GetStarted extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    id: PropTypes.number,
    leadDropID: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
    code: PropTypes.string,
    updatedAt: PropTypes.string,
    pinExpiresAt: PropTypes.string,
    consentPinCount: PropTypes.number,
    bookingID: PropTypes.string,
    token: PropTypes.string,
    onSubmit: PropTypes.func,
    bankCases: PropTypes.arrayOf(PropTypes.object),
    setLoading: PropTypes.func.isRequired,
    mobilePrefix: PropTypes.string,
    mobile: PropTypes.string,
    consentTypeID: PropTypes.string,
  }
  constructor(props) {
    super(props);
    this.state = {
      isError: false,
      errMessage: null,
      id: props.id,
      leadDropID: props.leadDropID,
      code: props.code,
      updatedAt: props.updatedAt,
      pinExpiresAt: props.pinExpiresAt,
      consentPinCount: props.consentPinCount,
      openConsentPinModal: false,
      pinRequestable: true,
      consentTypeID: null,
    };
    this.hasSentConsent = false;
  }
  componentWillReceiveProps(props) {
    this.setState({
      id: props.id,
      leadDropID: props.leadDropID,
      code: props.code,
      updatedAt: props.updatedAt,
      pinExpiresAt: props.pinExpiresAt,
      consentPinCount: props.consentPinCount,
      consentTypeID: props.consentTypeID,
    }, () => {
      if (!this.hasSentConsent && !this.hasStatus('lead-dropped') && this.state.consentTypeID === '1') {
        this.getStarted({
          agreedToTerms: true,
        });
      }
    });
  }
  setLoading = (loading = false) => {
    if (this.props.setLoading) {
      return this.props.setLoading(loading);
    }
    return Promise.resolve();
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  async getStarted(oldBody = {}) {
    this.hasSentConsent = true;
    await this.setLoading(true);
    const { t } = this.props;
    let res;
    let errMessage = `${t('An error occurred. Please try again', { ns: TRANSLATION_FILES.translation })}.`;
    const { store } = this.context;
    const body = Object.assign(oldBody, {
      bankCases: this.props.bankCases || [],
    });
    try {
      res = await store.dispatch(fetchM(`/bookings/${this.props.bookingID}/loan_trackers/`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
        body: JSON.stringify(body),
      }));
    } catch (e) {
      await this.setLoading(false);
      if (e.res && e.res.status >= 400 && e.res.status < 500) {
        errMessage = await e.res.text();
      } else {
        Bugsnag.notifyException(e);
      }
      await this.setComponentState({
        isError: true,
        errMessage: errMessage.trim(),
      });
      return null;
    }
    await this.setLoading(false);
    if (!res && !res.ok) {
      await this.setComponentState({
        isError: true,
        errMessage,
      });
      return null;
    }
    await this.setComponentState({
      isError: false,
      errMessage: null,
      openConsentPinModal: this.state.consentTypeID !== '1',
    });
    const data = await res.json();
    if (this.props.onSubmit) {
      this.props.onSubmit(data);
    }
    return data;
  }
  hasStatus(status) {
    switch (status) {
      case 'lead-dropped':
        return this.state.id < 1 && this.state.leadDropID > 0;
      case 'lead-added':
        return this.state.id > 0;
      default:
        return false;
    }
  }
  renderLeadDrop(openConsentPinModal) {
    const { t } = this.props;
    return (
      <div>
        {
          this.hasStatus('lead-dropped') ?
            <Modal
              closeIcon
              open={openConsentPinModal}
              onClose={() => this.setComponentState({ openConsentPinModal: false })}
              size="tiny"
            >
              <Header content={t('Refer to bankers')} />
              <Modal.Content>
                <ConsentPin
                  bookingID={this.props.bookingID}
                  errMessage={this.state.errMessage}
                  isError={this.state.isError}
                  leadDropID={this.props.leadDropID}
                  getStarted={data => this.getStarted(data)}
                  setLoading={this.setLoading}
                  mobilePrefix={this.props.mobilePrefix}
                  mobile={this.props.mobile}
                  onClose={() => this.setComponentState({ openConsentPinModal: false })}
                  onErrDismiss={() => this.setState({ isError: false })}
                  onPinRequestableChange={pr => this.setComponentState({ pinRequestable: pr })}
                />
              </Modal.Content>
            </Modal> : ''
        }
      </div>
    );
  }
  render() {
    const { t } = this.props;
    return (
      <div className="row">
        <div className="center aligned sixteen wide column">
          {
            this.hasStatus('lead-added') ? null : this.renderLeadDrop(this.state.openConsentPinModal)
          }
          {
            !this.hasStatus('lead-added') ? (
              <Button
                positive
                content={t(this.state.consentTypeID === '1' ? 'Get Started' : 'Send SMS Consent Pin to Purchaser')}
                onClick={(e) => {
                  e.preventDefault();
                  if (this.state.pinRequestable) {
                    this.getStarted({
                      agreedToTerms: true,
                    });
                  } else {
                    this.setState({ openConsentPinModal: this.state.consentTypeID !== '1' });
                  }
                }}
              />
            ) : null
          }
        </div>
      </div>
    );
  }
}

export default withTranslation(namespaces)(GetStarted);



// WEBPACK FOOTER //
// ./src/containers/LoanTracker/GetStarted.jsx